import { useController } from 'react-hook-form';

import { useIntl } from '@zenbusiness/application-commons-intl';

import { buildFieldName } from '#client/utils/form';

import { FIELD_NAMES } from '../../constants';

const MAX_LENGTH = 100;

export default function useAddress2Field({ namePrefix, validation } = {}) {
  const { formatMessage } = useIntl();

  const defaultValidation = {
    maxLength: {
      message: formatMessage(
        { id: 'shopping.component.addressFieldset.address2Field.error.maxLength' },
        { label: 'Address line 2', maxLength: MAX_LENGTH }
      ),
      value: MAX_LENGTH
    }
  };

  const fieldName = buildFieldName(FIELD_NAMES.ADDRESS_2, namePrefix);

  const {
    field: { onBlur, ...field },
    fieldState: { error }
  } = useController({
    defaultValue: '',
    name: fieldName,
    rules: { ...defaultValidation, ...validation }
  });

  const handleBlur = (e) => {
    field.onChange(e.target.value.trim());
  };

  return {
    error,
    field: {
      ...field,
      value: field.value ?? '',
      onBlur: handleBlur
    }
  };
}
